import React, {Dispatch, FC, SetStateAction, useEffect} from 'react';
import {Col, message, Row} from "antd";
import {useAppDispatch, useAppSelector} from "../../../../../store/store";
import {clearDeleteMessageTemplate, deleteMessageTemplate} from "../../../../../store/reducers/messageTemplatesReducer/messageTemplatesReducer";
import {DeleteOutlined} from "@ant-design/icons";
import {renderSuccessModal} from "../../../../../components/UI/StatusModals/renderSuccessModal";
import {CustomModal} from "../../../../../components/UI/AntCustom/CustomModal";
import {CustomButton} from "../../../../../components/UI/AntCustom/CustomButton";
import {defineMessages, useIntl} from "react-intl";
import {CommonButtonMessages} from "../../../../../intl/commonMessages/CommonButtonMessages";

const DeleteMessageTemplateModalMessages = defineMessages({
  title: {
    id: "deleteMessageTemplateModal.title",
    defaultMessage: "Delete message template",
  },
  success: {
    id: "deleteMessageTemplateModal.success",
    defaultMessage: "Message template has been successfully deleted",
  },
  warn: {
    id: "deleteMessageTemplateModal.warn",
    defaultMessage: "Are you sure you want to delete this message template?",
  },
})

interface IDeleteMessageTemplateModal {
  templateId: number;
  templateName: string;
  isModalVisible: boolean;
  setIsModalVisible: Dispatch<SetStateAction<boolean>>;
  onSuccess?: () => void;
}

export const DeleteMessageTemplateModal: FC<IDeleteMessageTemplateModal> = ({
  templateId,
  templateName,
  isModalVisible,
  setIsModalVisible,
  onSuccess,
}) => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const {
    isLoading,
    isSuccess,
    errorMessage,
  } = useAppSelector(state => state.messageTemplates.delete);

  useEffect(() => {
    return () => {
      dispatch(clearDeleteMessageTemplate());
    }
  }, [])

  useEffect(() => {
    if (!isLoading) {
      if (isSuccess) {
        renderSuccessModal(intl.formatMessage(DeleteMessageTemplateModalMessages.success), () => {
          setIsModalVisible(false);
          if (onSuccess) {
            onSuccess();
          }
        });
      }
      if (errorMessage) {
        message.error(errorMessage);
      }
    }
  }, [isSuccess, errorMessage, isLoading, intl, setIsModalVisible, onSuccess])

  return (
    <CustomModal
      title={intl.formatMessage(DeleteMessageTemplateModalMessages.title)}
      open={isModalVisible}
      onCancel={() => setIsModalVisible(false)}
      centered
      footer={null}
    >
      <div>{intl.formatMessage(DeleteMessageTemplateModalMessages.warn)}</div>
      {templateName && (
        <div style={{ marginTop: 8, fontWeight: 600 }}>{templateName}</div>
      )}
      <Row gutter={8} style={{marginTop: 24}}>
        <Col span={12}>
          <CustomButton
            style={{width: "100%"}}
            heightSize={'m'}
            onClick={() => setIsModalVisible(false)}
          >
            {intl.formatMessage(CommonButtonMessages.cancel)}
          </CustomButton>
        </Col>
        <Col span={12}>
          <CustomButton
            style={{width: "100%"}}
            heightSize={'m'}
            type={'primary'}
            icon={<DeleteOutlined />}
            danger
            loading={isLoading}
            onClick={() => dispatch(deleteMessageTemplate({ messageTemplateId: templateId }))}
          >
            {intl.formatMessage(CommonButtonMessages.delete)}
          </CustomButton>
        </Col>
      </Row>
    </CustomModal>
  );
};

